(() => {
  const KEY = 'dawn_newsletter_popup_last';

  function isHomePageOnlyAllowed(el) {
    const homeOnly = el.dataset.homeOnly === 'true';
    if (!homeOnly) return true;

    // Dawn: homepage is usually "/"
    return window.location.pathname === '/' || window.location.pathname === '/index.html';
  }

  function getCooldownMs(el) {
    const days = Number(el.dataset.cooldownDays || '0');
    return Math.max(0, days) * 24 * 60 * 60 * 1000;
  }

  function isInCooldown(el) {
    const cooldown = getCooldownMs(el);
    if (cooldown === 0) return false;

    try {
      const last = Number(localStorage.getItem(KEY) || '0');
      return last > 0 && (Date.now() - last) < cooldown;
    } catch (e) {
      return false;
    }
  }

  function markShown() {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }

  function openPopup(el) {
    if (!el.hasAttribute('hidden')) return;
    el.removeAttribute('hidden');

    const dialog = el.querySelector('.newsletter-popup__dialog');
    // basic focus
    requestAnimationFrame(() => dialog && dialog.focus());
    document.documentElement.classList.add('overflow-hidden');

    markShown();
  }

  function closePopup(el) {
    if (el.hasAttribute('hidden')) return;
    el.setAttribute('hidden', '');
    document.documentElement.classList.remove('overflow-hidden');
    markShown(); // also suppress after close
  }

  function setup(el) {
    if (!isHomePageOnlyAllowed(el)) return;
    if (isInCooldown(el)) return;

    const scrollPercent = Number(el.dataset.scrollPercent || '40');
    const delaySeconds = Number(el.dataset.delaySeconds || '0');
    let eligibleByTime = delaySeconds === 0;
    let opened = false;

    if (delaySeconds > 0) {
      window.setTimeout(() => { eligibleByTime = true; }, delaySeconds * 1000);
    }

    const onScroll = () => {
      if (opened || !eligibleByTime) return;

      const doc = document.documentElement;
      const scrollTop = window.scrollY || doc.scrollTop;
      const scrollHeight = (doc.scrollHeight - window.innerHeight);
      if (scrollHeight <= 0) return;

      const percent = (scrollTop / scrollHeight) * 100;
      if (percent >= scrollPercent) {
        opened = true;
        openPopup(el);
        window.removeEventListener('scroll', onScroll, { passive: true });
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    // Close handlers
    el.addEventListener('click', (e) => {
      const target = e.target;
      if (target && target.matches('[data-close]')) closePopup(el);
    });

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !el.hasAttribute('hidden')) closePopup(el);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.newsletter-popup').forEach(setup);
  });
})();